import { actionCreatorFactory } from 'typescript-fsa';

export namespace SearchFilterAction {
  const actionCreator = actionCreatorFactory('SearchFilter');

  export const setSearch = actionCreator<string>('SET_SEARCH');
  export const destroy = actionCreator('DESTROY');
}
